var parcelRequire = (function (e, r, n, t) {
    var i = 'function' == typeof parcelRequire && parcelRequire,
        o = 'function' == typeof require && require;
    function u(n, t) {
        if (!r[n]) {
            if (!e[n]) {
                var f = 'function' == typeof parcelRequire && parcelRequire;
                if (!t && f) return f(n, !0);
                if (i) return i(n, !0);
                if (o && 'string' == typeof n) return o(n);
                var c = new Error("Cannot find module '" + n + "'");
                throw ((c.code = 'MODULE_NOT_FOUND'), c);
            }
            (p.resolve = function (r) {
                return e[n][1][r] || r;
            }),
                (p.cache = {});
            var l = (r[n] = new u.Module(n));
            e[n][0].call(l.exports, p, l, l.exports, this);
        }
        return r[n].exports;
        function p(e) {
            return u(p.resolve(e));
        }
    }
    (u.isParcelRequire = !0),
        (u.Module = function (e) {
            (this.id = e), (this.bundle = u), (this.exports = {});
        }),
        (u.modules = e),
        (u.cache = r),
        (u.parent = i),
        (u.register = function (r, n) {
            e[r] = [
                function (e, r) {
                    r.exports = n;
                },
                {},
            ];
        });
    for (var f = 0; f < n.length; f++) u(n[f]);
    if (n.length) {
        var c = u(n[n.length - 1]);
        'object' == typeof exports && 'undefined' != typeof module
            ? (module.exports = c)
            : 'function' == typeof define && define.amd
            ? define(function () {
                  return c;
              })
            : t && (this[t] = c);
    }
    return u;
})(
    {
        B9qw: [function (require, module, exports) {}, {}],
        wntC: [
            function (require, module, exports) {
                'use strict';
                function e(e, t) {
                    if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
                }
                function t(e, t) {
                    for (var n = 0; n < t.length; n++) {
                        var i = t[n];
                        (i.enumerable = i.enumerable || !1),
                            (i.configurable = !0),
                            'value' in i && (i.writable = !0),
                            Object.defineProperty(e, i.key, i);
                    }
                }
                function n(e, n, i) {
                    return n && t(e.prototype, n), i && t(e, i), e;
                }
                Object.defineProperty(exports, '__esModule', { value: !0 }),
                    (exports.RangeSlider = void 0),
                    require('./rangeSlider.css');
                var i = {
                        className: '',
                        value: 0,
                        draggerSize: 12,
                        barHeight: 2,
                        onChange: null,
                        min: 0,
                        max: 100,
                        precision: 0,
                    },
                    a = (function () {
                        function t(n, a) {
                            e(this, t),
                                (this.options = Object.assign({}, i, a)),
                                (this.parent = n),
                                (this.isMoving = !1),
                                (this.container = null),
                                (this.dragger = null),
                                (this.bar = null),
                                (this._handleDragStart = this._handleDragStart.bind(this)),
                                (this._handleDragEnd = this._handleDragEnd.bind(this)),
                                (this._handleDragging = this._handleDragging.bind(this)),
                                (this._handleResize = this._handleResize.bind(this)),
                                this._init();
                        }
                        return (
                            n(t, [
                                {
                                    key: '_init',
                                    value: function () {
                                        this._render();
                                        var e = this._calculatePosition(this.options.value);
                                        this._updateUI(e);
                                    },
                                },
                                {
                                    key: '_createContainer',
                                    value: function () {
                                        var e = document.createElement('div');
                                        return (
                                            (e.className = 'range-slider '.concat(this.options.className)),
                                            (e.style.height = ''.concat(this.options.barHeight, 'px')),
                                            (this.container = e),
                                            e
                                        );
                                    },
                                },
                                {
                                    key: '_createBar',
                                    value: function () {
                                        var e = document.createElement('span');
                                        return (
                                            (e.style.height = ''.concat(this.options.barHeight, 'px')),
                                            (e.style.paddingLeft = ''.concat(this.options.draggerSize / 2, 'px')),
                                            (e.style.paddingRight = ''.concat(this.options.draggerSize / 2, 'px')),
                                            (e.className = 'progress-bar'),
                                            (this.bar = e),
                                            e
                                        );
                                    },
                                },
                                {
                                    key: '_createDragger',
                                    value: function () {
                                        var e = document.createElement('span');
                                        return (
                                            (e.style.width = ''.concat(this.options.draggerSize, 'px')),
                                            (e.style.height = ''.concat(this.options.draggerSize, 'px')),
                                            (e.style.top = '-'.concat(
                                                (this.options.draggerSize - this.options.barHeight) / 2,
                                                'px',
                                            )),
                                            (e.className = 'progress-dragger'),
                                            (this.dragger = e),
                                            e
                                        );
                                    },
                                },
                                {
                                    key: '_calculateValue',
                                    value: function (e, t) {
                                        return +(
                                            (e * (this.options.max - this.options.min)) / t +
                                            this.options.min
                                        ).toFixed(this.options.precision);
                                    },
                                },
                                {
                                    key: '_calculatePosition',
                                    value: function (e) {
                                        var t = this._getPositionMax();
                                        return ((e - this.options.min) * t) / (this.options.max - this.options.min);
                                    },
                                },
                                {
                                    key: '_createSlider',
                                    value: function () {
                                        var e = this._createContainer(),
                                            t = this._createBar(),
                                            n = this._createDragger();
                                        return t.appendChild(n), e.appendChild(t), this._bindEvent(e), e;
                                    },
                                },
                                {
                                    key: '_move',
                                    value: function (e) {
                                        if ((e.cancelable && e.preventDefault(), this.isMoving)) {
                                            var t = this._getPositionMax(),
                                                n = this.container.getBoundingClientRect().left;
                                            (n += document.documentElement.scrollLeft) < 0 && (n = Math.abs(n) / 2);
                                            var i = (e.pageX || e.touches[0].pageX) - n - this.dragger.offsetWidth / 2,
                                                a = i > t ? t : i < 0 ? 0 : i,
                                                s = this._calculateValue(a, t);
                                            this.setValue(s), this.options.onChange && this.options.onChange(s);
                                        }
                                    },
                                },
                                {
                                    key: '_getPositionMax',
                                    value: function () {
                                        return this.container.offsetWidth - this.dragger.offsetWidth;
                                    },
                                },
                                {
                                    key: '_updateUI',
                                    value: function (e) {
                                        var t = this._getPositionMax();
                                        this.dragger.style.left = ''.concat(e, 'px');
                                        var n = (e / t) * 100;
                                        this.bar.style.width = ''.concat(n, '%');
                                    },
                                },
                                {
                                    key: '_handleDragStart',
                                    value: function (e) {
                                        (this.isMoving = !0), this._move(e);
                                    },
                                },
                                {
                                    key: '_handleDragEnd',
                                    value: function (e) {
                                        this.isMoving = !1;
                                    },
                                },
                                {
                                    key: '_handleDragging',
                                    value: function (e) {
                                        this._move(e);
                                    },
                                },
                                {
                                    key: '_handleResize',
                                    value: function (e) {
                                        this._init();
                                    },
                                },
                                {
                                    key: '_bindEvent',
                                    value: function (e) {
                                        e.addEventListener('mousedown', this._handleDragStart, !0),
                                            e.addEventListener('touchstart', this._handleDragStart, {
                                                passive: !1,
                                                capture: !0,
                                            }),
                                            document.addEventListener('mouseup', this._handleDragEnd, !0),
                                            document.addEventListener('touchend', this._handleDragEnd, !0),
                                            document.addEventListener('mousemove', this._handleDragging, !0),
                                            e.addEventListener('touchmove', this._handleDragging, !0),
                                            window.addEventListener('resize', this._handleResize, !0);
                                    },
                                },
                                {
                                    key: '_removeEvent',
                                    value: function () {
                                        this.container &&
                                            (container.removeEventListener('mousedown', this._handleDragStart, !0),
                                            container.removeEventListener('touchstart', this._handleDragStart, !0),
                                            document.removeEventListener('mouseup', this._handleDragEnd, !0),
                                            document.removeEventListener('touchend', this._handleDragEnd, !0),
                                            document.removeEventListener('mousemove', this._handleDragging, !0),
                                            container.removeEventListener('touchmove', this._handleDragging, !0),
                                            window.removeEventListener('resize', this._handleResize, !0));
                                    },
                                },
                                {
                                    key: '_render',
                                    value: function () {
                                        var e = this._createSlider();
                                        this.parent && ((this.parent.innerHTML = ''), this.parent.appendChild(e));
                                    },
                                },
                                {
                                    key: 'destroy',
                                    value: function () {
                                        this._removeEvent();
                                    },
                                },
                                {
                                    key: 'getValue',
                                    value: function () {
                                        return this.options.value;
                                    },
                                },
                                {
                                    key: 'setValue',
                                    value: function (e) {
                                        this.options.value = e;
                                        var t = this._calculatePosition(e);
                                        this._updateUI(t);
                                    },
                                },
                            ]),
                            t
                        );
                    })();
                exports.RangeSlider = a;
            },
            { './rangeSlider.css': 'B9qw' },
        ],
        G4J6: [
            function (require, module, exports) {
                'use strict';
                Object.defineProperty(exports, '__esModule', { value: !0 });
                var e = require('./rangeSlider');
                Object.keys(e).forEach(function (r) {
                    'default' !== r &&
                        '__esModule' !== r &&
                        Object.defineProperty(exports, r, {
                            enumerable: !0,
                            get: function () {
                                return e[r];
                            },
                        });
                });
            },
            { './rangeSlider': 'wntC' },
        ],
        gQPQ: [
            function (require, module, exports) {
                'use strict';
                Object.defineProperty(exports, '__esModule', { value: !0 }),
                    (exports.AudioPlayer = void 0),
                    require('./audioPlayer.css');
                var e = require('../rangeSlider');
                function t(e, t) {
                    if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
                }
                function i(e, t) {
                    for (var i = 0; i < t.length; i++) {
                        var n = t[i];
                        (n.enumerable = n.enumerable || !1),
                            (n.configurable = !0),
                            'value' in n && (n.writable = !0),
                            Object.defineProperty(e, n.key, n);
                    }
                }
                function n(e, t, n) {
                    return t && i(e.prototype, t), n && i(e, n), e;
                }
                var a = { parent: null, autoPlay: !1, duration: 0, url: '' },
                    r = (function () {
                        function i(e) {
                            t(this, i),
                                (this.options = Object.assign({}, a, e)),
                                (this.container = null),
                                (this.timeHoler = null),
                                (this.toggleBtn = null),
                                (this.slider = null),
                                (this.isPlaying = !1),
                                (this.player = null),
                                (this.sliderId = this._getSliderId()),
                                (this.togglePlay = this.togglePlay.bind(this)),
                                this._init();
                        }
                        return (
                            n(i, [
                                {
                                    key: '_init',
                                    value: function () {
                                        (this.container = this._createUI()),
                                            this.options.parent &&
                                                ((this.options.parent.innerHTML = ''),
                                                this.options.parent.appendChild(this.container),
                                                this._initialPlayer(),
                                                this._initialEvents());
                                    },
                                },
                                {
                                    key: '_initialEvents',
                                    value: function () {
                                        this.toggleBtn.onclick = this.togglePlay;
                                    },
                                },
                                {
                                    key: '_initialPlayer',
                                    value: function () {
                                        var e = this;
                                        if (!this.options.url) throw new Error('missing audio url');
                                        var t = (this.player = new Audio(this.options.url));
                                        (this.player.onloadedmetadata = function () {
                                            e._initializeSlider(e.player.duration),
                                                e._updateTimeDisplay(e.player.currentTime, e.player.duration);
                                        }),
                                            (this.player.ontimeupdate = function (t) {
                                                var i = t.currentTarget.currentTime;
                                                e.slider.setValue(i), e._updateTimeDisplay(i, e.player.duration);
                                            }),
                                            (this.player.ondurationchange = function (t) {
                                                e._initializeSlider(t.currentTarget.duration);
                                            }),
                                            (this.player.onended = function () {
                                                e._playStatusChange(!1);
                                            }),
                                            (this.player.onpause = function () {
                                                e._playStatusChange(!1);
                                            }),
                                            (this.player.onerror = function () {
                                                e._playStatusChange(!1);
                                            }),
                                            (this.player.preload = 'metadata'),
                                            document.addEventListener(
                                                'WeixinJSBridgeReady',
                                                function () {
                                                    t.load();
                                                },
                                                !1,
                                            ),
                                            this.container.appendChild(this.player);
                                    },
                                },
                                {
                                    key: '_removeEvents',
                                    value: function () {
                                        this.toggleBtn.onclick = void 0;
                                    },
                                },
                                {
                                    key: 'togglePlay',
                                    value: function () {
                                        !this.isPlaying ? this.play() : this.pause();
                                    },
                                },
                                {
                                    key: 'play',
                                    value: function () {
                                        this.player.play(), this._playStatusChange(!0);
                                    },
                                },
                                {
                                    key: 'pause',
                                    value: function () {
                                        this.player.pause(), this._playStatusChange(!1);
                                    },
                                },
                                {
                                    key: '_playStatusChange',
                                    value: function (e) {
                                        (this.isPlaying = e),
                                            (this.toggleBtn.className = 'icon icon-'.concat(
                                                this.isPlaying ? 'pause' : 'play',
                                            ));
                                    },
                                },
                                {
                                    key: '_initializeSlider',
                                    value: function (t) {
                                        var i = this,
                                            n = document.querySelector('#'.concat(this.sliderId));
                                        n &&
                                            (this.slider && n.removeChild(n.firstChild),
                                            (this.slider = new e.RangeSlider(n, {
                                                max: t,
                                                onChange: function (e) {
                                                    i.player.currentTime = e;
                                                },
                                            })));
                                    },
                                },
                                {
                                    key: '_getSliderId',
                                    value: function () {
                                        return String.fromCharCode(65 + Math.floor(26 * Math.random())) + Date.now();
                                    },
                                },
                                {
                                    key: '_createUI',
                                    value: function () {
                                        var e = document.createElement('div');
                                        e.className = 'audio-player';
                                        var t = document.createElement('div');
                                        (t.className = 'player-section player-toggle'),
                                            (this.toggleBtn = document.createElement('span')),
                                            (this.toggleBtn.className = 'icon icon-play'),
                                            t.appendChild(this.toggleBtn),
                                            e.appendChild(t);
                                        var i = document.createElement('div');
                                        (i.className = 'player-section player-progress'),
                                            (i.innerHTML = '<div class="player-slider" id="'.concat(
                                                this.sliderId,
                                                '"></div>',
                                            )),
                                            e.appendChild(i);
                                        var n = document.createElement('div');
                                        return (
                                            (n.className = 'player-section player-time'),
                                            (this.timeHoler = document.createElement('div')),
                                            (this.timeHoler.className = 'time'),
                                            (this.timeHoler.innerText = '00:00'),
                                            n.appendChild(this.timeHoler),
                                            e.appendChild(n),
                                            e
                                        );
                                    },
                                },
                                {
                                    key: '_updateTimeDisplay',
                                    value: function (e, t) {
                                        (e = this._formatTime2HHMMSS(e)), (t = this._formatTime2HHMMSS(t));
                                        var i = ''.concat(e, ' / ').concat(t);
                                        '00:00' === t && (i = ''.concat(e)), (this.timeHoler && (this.timeHoler.innerText = i));
                                    },
                                },
                                {
                                    key: '_formatTime2HHMMSS',
                                    value: function (e) {
                                        var t = new Date(null);
                                        t.setMilliseconds(1e3 * e);
                                        var i = t.toISOString().substr(11, 8),
                                            n = i.split(':');
                                        return n.length > 2 && '00' === n[0] && (i = n.slice(1).join(':')), i;
                                    },
                                },
                                {
                                    key: 'destroy',
                                    value: function () {
                                        this._removeEvents(),
                                            this.container && this.container.remove && this.container.remove();
                                    },
                                },
                            ]),
                            i
                        );
                    })();
                exports.AudioPlayer = r;
            },
            { './audioPlayer.css': 'B9qw', '../rangeSlider': 'G4J6' },
        ],
        vJnp: [
            function (require, module, exports) {
                'use strict';
                Object.defineProperty(exports, '__esModule', { value: !0 });
                var e = require('./audioPlayer');
                Object.keys(e).forEach(function (r) {
                    'default' !== r &&
                        '__esModule' !== r &&
                        Object.defineProperty(exports, r, {
                            enumerable: !0,
                            get: function () {
                                return e[r];
                            },
                        });
                });
            },
            { './audioPlayer': 'gQPQ' },
        ],
        ul3z: [
            function (require, module, exports) {
                'use strict';
                function e(e, t) {
                    if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
                }
                function t(e, t) {
                    for (var i = 0; i < t.length; i++) {
                        var n = t[i];
                        (n.enumerable = n.enumerable || !1),
                            (n.configurable = !0),
                            'value' in n && (n.writable = !0),
                            Object.defineProperty(e, n.key, n);
                    }
                }
                function i(e, i, n) {
                    return i && t(e.prototype, i), n && t(e, n), e;
                }
                Object.defineProperty(exports, '__esModule', { value: !0 }),
                    (exports.VideoPlayer = void 0),
                    require('./videoPlayer.css');
                var n = { parent: null, autoPlay: !1, duration: 0, isInlinePlay: !0, url: '' },
                    a = (function () {
                        function t(i) {
                            e(this, t),
                                (this.options = Object.assign({}, n, i)),
                                (this.container = null),
                                (this.player = null),
                                this._init();
                        }
                        return (
                            i(t, [
                                {
                                    key: '_init',
                                    value: function () {
                                        (this.container = this._createUI()),
                                            this.options.parent &&
                                                ((this.options.parent.innerHTML = ''),
                                                this.options.parent.appendChild(this.container),
                                                this._initialPlayer());
                                    },
                                },
                                {
                                    key: '_initialPlayer',
                                    value: function () {
                                        var e = this;
                                        if (!this.options.url) throw new Error('missing video url');
                                        if (
                                            ((this.player = document.createElement('video')),
                                            window.navigator.userAgent.indexOf('QQBrowser') > -1
                                                ? (this.player.src = this.options.url)
                                                : (this.player.src = this.options.url + '#t=0.5'),
                                            this.options.isInlinePlay)
                                        )
                                            this.player.setAttribute('controls', 'controls'),
                                                this.player.setAttribute('playsinline', 'true'),
                                                this.player.setAttribute('webkit-playsinline', 'true'),
                                                this.player.setAttribute('preload', 'metadata'),
                                                this.player.setAttribute('x5-playsinline', 'true'),
                                                this.player.setAttribute('webkit-controlslist', 'nodownload'),
                                                this.player.setAttribute('x5-controlslist', 'nodownload'),
                                                this.player.setAttribute('controlslist', 'nodownload');
                                        else {
                                            var t = document.createElement('span');
                                            (t.className = 'icon icon-video-start-play'),
                                                (t.onclick = function () {
                                                    e._openPopup();
                                                }),
                                                this.container.appendChild(t);
                                        }
                                        document.addEventListener(
                                            'WeixinJSBridgeReady',
                                            function () {
                                                player.load();
                                            },
                                            !1,
                                        ),
                                            this.container.appendChild(this.player);
                                    },
                                },
                                {
                                    key: 'play',
                                    value: function () {
                                        this.player.play();
                                    },
                                },
                                {
                                    key: 'pause',
                                    value: function () {
                                        this.player.pause();
                                    },
                                },
                                {
                                    key: '_createUI',
                                    value: function () {
                                        var e = document.createElement('div');
                                        return (e.className = 'video-player'), e;
                                    },
                                },
                                {
                                    key: '_openPopup',
                                    value: function () {
                                        var e = document.createElement('div');
                                        e.className = 'video-player-popup';
                                        var t = document.createElement('div');
                                        (t.className = 'popup-video-wrapper'), e.appendChild(t);
                                        var i = document.createElement('span');
                                        (i.className = 'icon icon-video-close'),
                                            (i.onclick = function () {
                                                document.body.removeChild(e);
                                            });
                                        var n = this.player.cloneNode(!0);
                                        n.setAttribute('controls', 'controls'),
                                            t.appendChild(n),
                                            n.play(),
                                            t.appendChild(i),
                                            document.body.appendChild(e);
                                    },
                                },
                                {
                                    key: 'destroy',
                                    value: function () {
                                        this.container && this.container.remove && this.container.remove();
                                    },
                                },
                            ]),
                            t
                        );
                    })();
                exports.VideoPlayer = a;
            },
            { './videoPlayer.css': 'B9qw' },
        ],
        gdOT: [
            function (require, module, exports) {
                'use strict';
                Object.defineProperty(exports, '__esModule', { value: !0 });
                var e = require('./videoPlayer');
                Object.keys(e).forEach(function (r) {
                    'default' !== r &&
                        '__esModule' !== r &&
                        Object.defineProperty(exports, r, {
                            enumerable: !0,
                            get: function () {
                                return e[r];
                            },
                        });
                });
            },
            { './videoPlayer': 'ul3z' },
        ],
        o0va: [
            function (require, module, exports) {
                'use strict';
                Object.defineProperty(exports, '__esModule', { value: !0 }), (exports.MediaPlayer = void 0);
                var e = require('./audioPlayer'),
                    t = require('./videoPlayer');
                function a(e, t) {
                    if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
                }
                function r(e, t) {
                    for (var a = 0; a < t.length; a++) {
                        var r = t[a];
                        (r.enumerable = r.enumerable || !1),
                            (r.configurable = !0),
                            'value' in r && (r.writable = !0),
                            Object.defineProperty(e, r.key, r);
                    }
                }
                function i(e, t, a) {
                    return t && r(e.prototype, t), a && r(e, a), e;
                }
                var n = [];
                function o() {
                    document.addEventListener(
                        'play',
                        function (e) {
                            for (var t = 0, a = n.length; t < a; t++) n[t].player != e.target && n[t].player.pause();
                        },
                        !0,
                    );
                }
                o();
                var l = { parent: document.body, autoPlay: !1, duration: 0, url: '', isInlinePlay: !0 },
                    u = (function () {
                        function r(e, t) {
                            a(this, r),
                                (this.options = Object.assign({}, l, t)),
                                (this.type = e),
                                this._init(this.options);
                        }
                        return (
                            i(r, [
                                {
                                    key: '_init',
                                    value: function (e) {
                                        (this.player = this._createPlayer(e)), n.push(this.player);
                                    },
                                },
                                {
                                    key: '_createPlayer',
                                    value: function (a) {
                                        return 'audio' === this.type
                                            ? new e.AudioPlayer(a)
                                            : 'video' === this.type
                                            ? new t.VideoPlayer(a)
                                            : void 0;
                                    },
                                },
                                {
                                    key: 'play',
                                    value: function () {
                                        this.player && this.player.play();
                                    },
                                },
                                {
                                    key: 'pause',
                                    value: function () {
                                        this.player && this.player.pause();
                                    },
                                },
                                {
                                    key: 'destroy',
                                    value: function () {
                                        this.player && this.player.destroy();
                                    },
                                },
                            ]),
                            r
                        );
                    })();
                exports.MediaPlayer = u;
            },
            { './audioPlayer': 'vJnp', './videoPlayer': 'gdOT' },
        ],
        Focm: [
            function (require, module, exports) {
                'use strict';
                Object.defineProperty(exports, '__esModule', { value: !0 });
                var e = require('./rangeSlider');
                Object.keys(e).forEach(function (r) {
                    'default' !== r &&
                        '__esModule' !== r &&
                        Object.defineProperty(exports, r, {
                            enumerable: !0,
                            get: function () {
                                return e[r];
                            },
                        });
                });
                var r = require('./audioPlayer');
                Object.keys(r).forEach(function (e) {
                    'default' !== e &&
                        '__esModule' !== e &&
                        Object.defineProperty(exports, e, {
                            enumerable: !0,
                            get: function () {
                                return r[e];
                            },
                        });
                });
                var t = require('./videoPlayer');
                Object.keys(t).forEach(function (e) {
                    'default' !== e &&
                        '__esModule' !== e &&
                        Object.defineProperty(exports, e, {
                            enumerable: !0,
                            get: function () {
                                return t[e];
                            },
                        });
                });
                var u = require('./mediaPlayer');
                Object.keys(u).forEach(function (e) {
                    'default' !== e &&
                        '__esModule' !== e &&
                        Object.defineProperty(exports, e, {
                            enumerable: !0,
                            get: function () {
                                return u[e];
                            },
                        });
                });
            },
            { './rangeSlider': 'G4J6', './audioPlayer': 'vJnp', './videoPlayer': 'gdOT', './mediaPlayer': 'o0va' },
        ],
    },
    {},
    ['Focm'],
    null,
);
//# sourceMappingURL=/index.map
